import { ExportTransportTypes } from 'constants/exportTypes';
import { NOTIFICATIONS_REFETCH_INTERVAL } from 'constants/notifications';

import { useQuery } from '@tanstack/react-query';
import { NotificationsCountResponse, getNotificationsCount } from 'config/requests/notifications';
import { getUnixTime, subDays } from 'date-fns';

type UseGetNotificationsCountReturnValue = {
  notificationsCount?: string;
  refetch: () => void;
};

export function useGetNotificationsCount(): UseGetNotificationsCountReturnValue {
  const getRequestParams = () => ({
    createdAtFrom: getUnixTime(subDays(new Date(), 2)),
    createdAtTo: getUnixTime(new Date()),
    transport: ExportTransportTypes.Admin,
    isViewed: 0,
  });

  const { data, refetch } = useQuery<NotificationsCountResponse>({
    queryKey: ['notificationsCount'],
    queryFn: () => getNotificationsCount(getRequestParams()),
    refetchInterval: NOTIFICATIONS_REFETCH_INTERVAL,
  });

  return { notificationsCount: data?.count, refetch };
}
